/* emv/types */
import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}
const tId = t.union([t.undefined, t.null, t.string]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

const AIDSchema = t.type({
  ACQUIERID: tOptional(t.string),
  AID: tOptional(t.string),
  AIDLEN: tOptional(t.string),
  DDOL: tOptional(t.string),
  ECTTLFLG: tOptional(t.string),
  FLOORLIMIT: tOptional(t.string),
  FLOORLIMITCHECK: tOptional(t.string),
  MAXTARGETPER: tOptional(t.string),
  ONLINEPIN: tOptional(t.string),
  PRIORITY: tOptional(t.string),
  RANDTRANSSEL: tOptional(t.string),
  RDCLSSFLMT: tOptional(t.string),
  RDCLSSFLMTFLG: tOptional(t.string),
  RDCLSSTXNLMT: tOptional(t.string),
  RDCLSSTXNLMTFLG: tOptional(t.string),
  RDCVMLMT: tOptional(t.string),
  RDCVMLMTFLG: tOptional(t.string),
  SELFLAG: tOptional(t.string),
  TACDEFAULT: tOptional(t.string),
  TACDENIAL: tOptional(t.string),
  TACONLINE: tOptional(t.string),
  TARGETPER: tOptional(t.string),
  TDOL: tOptional(t.string),
  TERMFLMT: tOptional(t.string),
  THRESHOLD: tOptional(t.string),
  VELOCITYCHECK: tOptional(t.string),
  VERSION: tOptional(t.string),
  ucStatusCheckFlg: tOptional(t.string),
  ucZeroAmtNoAllowed: tOptional(t.string),
});

const CAPKSchema = t.type({
  RID: t.string,
  KEYID: t.string,
  HASHIND: t.string,
  ARITHIND: t.string,
  MODULLEN: t.string,
  MODUL: t.string,
  EXPONENTLEN: t.string,
  EXPONENT: t.string,
  EXPDATE: t.string,
  CHECKSUM: t.string,
});

const AttributeCodec = t.intersection([
  t.type({
    Name: tOptional(t.string),
    For: tOptional(t.string),
    AID: tOptional(t.array(AIDSchema)),
    CAPK: tOptional(t.array(CAPKSchema)),
    ConfigName: t.string,
  }),
  t.partial({}),
]);

const DataCodec = t.type({
  id: tId,
  type: t.string,
  attributes: AttributeCodec,
});
export type Data = t.TypeOf<typeof DataCodec>;

export const EmvCodec = t.type(
  {
    errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
    data: tOptional(t.array(DataCodec)),
  },
  "EmvCodec"
);

export type Emv = t.TypeOf<typeof EmvCodec>;

export enum EmvActionTypes {
  FETCH = "@@emv/FETCH",
  FETCH_SUCCESS = "@@emv/FETCH_SUCCESS",
  FETCH_ERROR = "@@emv/FETCH_ERROR",
}

export interface EmvState {
  readonly loading: boolean;
  readonly data: Data[];
  readonly errors?: string;
}
